// extracted by mini-css-extract-plugin
module.exports = {"wrap":"MWKSctcNWXkg1lFg6-lG4","number":"Cjyy_Nvlon8jZ_0LO4l1Y","text":"kZNVtf4E8iGraMpVYa_qE"};